import React, { Component } from 'react';
import DateTime from 'react-datetime';

import Core from './../../Core/Core';
import AutoComplete from './../AutoComplete';
import FileList from './../FileList';
import FileUpload from './../FileUpload';

class ProposalForm extends Component {
  constructor(props) {
    super(props);

    this.onChange = props.onChange;

    this.handeInput = this.handeInput.bind(this);
    this.handleDate = this.handleDate.bind(this);

    this.DateTime = React.createRef();
    this.FileList = React.createRef();

    this.uploadDone = this.uploadDone.bind(this);
  }

  uploadDone() {
    this.FileList.current.load(this.FileList.current.props.path);
  }

  handeInput(event) {
    let value = event.target.type === 'checkbox' ? (event.target.checked === true ? 1 : 0) : event.target.value;

    let evt = null;
    let type = null;
    if (typeof value === 'string') {
      value = value.split('|');
      type = value[1];
      value = value[0];
    }

    if (event.target.name === 'conseilor') {
      evt = {
        target: {
          name: 'conseilor_type',
          value: type,
        },
      };
      this.onChange(evt);
    }

    if (event.target.name === 'sold' && value === 1) {
      let now = new Date().getTime() / 1000;
      evt = {
        target: {
          name: 'date_sold',
          value: now,
        },
      };
      this.onChange(evt);
    }

    evt = {
      target: {
        name: event.target.name,
        value: value,
      },
    };
    this.onChange(evt);
  }

  handleDate(ref, name, date) {
    ref.current.querySelector('.text-danger').style.display = 'none';
    ref.current.querySelector('.rdt .form-control').classList.remove('invalid');
    if (date._isAMomentObject == null) {
      ref.current.querySelector('.text-danger').style.display = 'initial';
      ref.current.querySelector('.rdt .form-control').classList.add('invalid');
      let evt = {
        target: {
          name: name,
          value: null,
        },
      };
      this.onChange(evt);
      return;
    } else {
      let evt = {
        target: {
          name: name,
          value: date.unix(),
        },
      };
      this.onChange(evt);
    }
  }

  render() {
    let dealerships =
      this.props.dealerships == null
        ? []
        : this.props.dealerships.map((d) => {
            return (
              <option key={d.shortname + ' - ' + d.name} value={d.name}>
                {d.name}
              </option>
            );
          });

    let conseilors =
      this.props.conseilors == null
        ? []
        : this.props.conseilors.map((c) => {
            if (this.props.proposal.shortname && this.props.proposal.shortname === c.shortname) {
              return (
                <option key={c.shortname + ' - ' + c.name} value={c.name + '|' + c.type}>
                  {c.name + ' - ' + c.shortname}
                </option>
              );
            } else {
              return null;
            }
          });

    let models =
      this.props.models == null || !Array.isArray(this.props.models)
        ? []
        : this.props.models.map((m) => {
            return (
              <option key={m.model} value={m.model}>
                {m.model}
              </option>
            );
          });

    return (
      <div className='fade modal show' id='addProposalModal' tabIndex='-1' role='dialog' aria-labelledby='addProposalModalLabel' aria-modal='true'>
        <div className='modal-dialog modal-full-height modal-right' role='document'>
          <div className='modal-content rounded-0 p-3'>
            <button type='button' className='close closeSideModal' data-dismiss='modal' aria-label='Close'>
              <span aria-hidden='true'>×</span>
            </button>
            <div className='modal-header'>
              <h4 className='modal-title' id='addProposalModalLabel'>
                {this.props.proposal.id ? 'Editer une proposition' : 'Ajouter une proposition'}
              </h4>
            </div>
            <div className='modal-body'>
              <div className='row'>
                <div className='col'>
                  <div className='form-group'>
                    <label className='h5 font-weight-bold mb-4'>Type :</label>
                    <div className='form-check form-check-inline ml-3'>
                      <input
                        className='form-check-input'
                        type='radio'
                        name='type'
                        id='radio_VPP'
                        value='VPP'
                        checked={this.props.proposal.type === 'VPP'}
                        onChange={this.handeInput}
                        required
                      />
                      <label className='form-check-label' htmlFor='radio_VPP'>
                        VPP
                      </label>
                    </div>
                    <div className='form-check form-check-inline'>
                      <input
                        className='form-check-input'
                        type='radio'
                        name='type'
                        id='radio_VD'
                        value='VD'
                        checked={this.props.proposal.type === 'VD'}
                        onChange={this.handeInput}
                      />
                      <label className='form-check-label' htmlFor='radio_VD'>
                        VD
                      </label>
                    </div>
                    <div className='form-check form-check-inline'>
                      <input
                        className='form-check-input'
                        type='radio'
                        name='type'
                        id='radio_SO'
                        value='SO'
                        checked={this.props.proposal.type === 'SO'}
                        onChange={this.handeInput}
                      />
                      <label className='form-check-label' htmlFor='radio_SO'>
                        SO
                      </label>
                    </div>
                    {(this.props.proposal.type === 'VPP' || this.props.proposal.type === 'VD') && (
                      <div className='form-group'>
                        <div className='form-check'>
                          <input
                            className='form-check-input'
                            type='checkbox'
                            name='eligible_so'
                            checked={this.props.proposal.eligible_so === 1}
                            onClick={this.handeInput}
                            id='eligible_so'
                          />
                          <label className='form-check-label' htmlFor='eligible_so'>
                            Eligible SO
                          </label>
                        </div>
                      </div>
                    )}
                    <div className='form-group'>
                      <label className='h5 font-weight-bold'>Affaire</label>
                      <select
                        className='form-control'
                        name='shortname'
                        value={this.props.proposal.shortname ? this.props.proposal.shortname : ''}
                        onChange={this.handeInput}
                        required
                      >
                        <option disabled value=''>
                          {' '}
                          -- Affaire --{' '}
                        </option>
                        {dealerships}
                      </select>
                    </div>

                    <div className='form-group'>
                      <label className='h5 font-weight-bold'>Vendeur</label>
                      <select
                        className='form-control'
                        name='conseilor'
                        value={this.props.proposal.conseilor ? this.props.proposal.conseilor + '|' + this.props.proposal.conseilor_type : ''}
                        onChange={this.handeInput}
                        required
                      >
                        <option disabled value=''>
                          {' '}
                          -- Vendeur --{' '}
                        </option>
                        {conseilors}
                      </select>
                    </div>

                    <div className='form-group' ref={this.DateTime}>
                      <label className='h5 font-weight-bold'>Date</label>
                      <DateTime
                        name='date'
                        timeFormat={false}
                        onChange={(date) => {
                          this.handleDate(this.DateTime, 'date', date);
                        }}
                        dateFormat='DD/MM/YYYY'
                        value={this.props.proposal.date != null ? this.props.proposal.date * 1000 : null}
                        required
                      />
                      <small className='text-danger form-text'>Ce champ doit contenir une date valide</small>
                    </div>
                    <div className='form-group'>
                      <label className='h5 font-weight-bold'>Nom du client</label>
                      <AutoComplete name={this.props.proposal.name ? this.props.proposal.name : ''} onChange={this.handeInput} />
                    </div>
                    <div className='form-group'>
                      <label className='h5 font-weight-bold'>Modèle</label>
                      <select
                        className='form-control'
                        name='model'
                        value={this.props.proposal.model ? this.props.proposal.model : ''}
                        onChange={this.handeInput}
                        required
                      >
                        <option disabled value=''>
                          {' '}
                          -- Modèle --{' '}
                        </option>
                        {models}
                      </select>
                    </div>
                    <div className='form-group'>
                      <div className='form-check pt-2'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          name='sl'
                          checked={this.props.proposal.sl == 1}
                          onClick={this.handeInput}
                          id='sl'
                        />
                        <label className='form-check-label' htmlFor='sl'>
                          Série Limitée
                        </label>
                      </div>
                    </div>
                    <label className='h5 font-weight-bold'>Prix tarif hors bonus malus</label>
                    <div className='input-group mb-3'>
                      <input
                        type='number'
                        min='0'
                        className='form-control'
                        name='price'
                        value={this.props.proposal.price ? this.props.proposal.price : ''}
                        onChange={this.handeInput}
                        required
                      />
                      <div className='input-group-append'>
                        <span className='input-group-text'>€</span>
                      </div>
                      <small className='text-danger form-text'>Ce champ doit contenir un nombre supérieur à 0.</small>
                    </div>
                    <label className='h5 font-weight-bold'>Remise + surestim (sans pool)</label>
                    <div className='input-group mb-3'>
                      <input
                        type='number'
                        min='0'
                        className='form-control'
                        name='discount'
                        value={this.props.proposal.discount || 0}
                        onChange={this.handeInput}
                        // required
                      />
                      <div className='input-group-append'>
                        <span className='input-group-text'>€</span>
                      </div>
                      <small className='text-danger form-text'>Ce champ doit contenir un nombre supérieur à 0.</small>
                    </div>
                  </div>
                  <label className='h5 font-weight-bold'>Reprise</label>
                  <div className='form-group'>
                    <span className='form-check form-check-inline py-2'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        name='is_takeover'
                        checked={this.props.proposal.is_takeover == 1}
                        onClick={this.handeInput}
                        id='is_takeover'
                      />
                      <label className='form-check-label' htmlFor='is_takeover'>
                        Reprise
                      </label>
                    </span>
                    <span className='form-check form-check-inline py-2'>
                      <input
                        className='form-check-input pl-5'
                        type='checkbox'
                        name='pac'
                        checked={this.props.proposal.pac == 1}
                        onClick={this.handeInput}
                        id='pac'
                      />
                      <label className='form-check-label' htmlFor='pac'>
                        PAC
                      </label>
                    </span>
                  </div>
                  {this.props.proposal.is_takeover === 1 && (
                    <div className='form-group'>
                      <label className='h5 font-weight-bold'>Fidé / Conquête</label>
                      <select
                        className='form-control'
                        name='loyalty_conquest'
                        value={this.props.proposal.loyalty_conquest ? this.props.proposal.loyalty_conquest : ''}
                        onChange={this.handeInput}
                      >
                        <option disabled value=''>
                          {' '}
                          -- Fidé / Conquête --{' '}
                        </option>
                        <option value='Fidé'>Fidé</option>
                        <option value='Conquête'>Conquête</option>
                      </select>
                    </div>
                  )}
                  {this.props.proposal.is_takeover === 1 && (
                    <div className='form-group'>
                      <div className='form-check'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          name='is_takeover_twelve'
                          checked={this.props.proposal.is_takeover_twelve == 1}
                          onClick={this.handeInput}
                          id='is_takeover_twelve'
                        />
                        <label className='form-check-label' htmlFor='is_takeover_twelve'>
                          Reprise > 12 ans
                        </label>
                      </div>
                    </div>
                  )}
                  <div className='form-group'>
                    <label className='h5 font-weight-bold'>Immatriculation reprise</label>
                    <input
                      type='text'
                      maxLength='100'
                      className='form-control'
                      name='code'
                      value={this.props.proposal.code ? this.props.proposal.code : ''}
                      onChange={this.handeInput}
                    />
                    <small className='text-danger form-text'>Ce champ doit contenir moins de 100 caractères.</small>
                  </div>

                  <div className='form-group'>
                    <div className='form-check form-check-inline'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        name='bundle'
                        checked={this.props.proposal.bundle == 1}
                        onClick={this.handeInput}
                        id='bundle'
                      />
                      <label className='form-check-label' htmlFor='bundle'>
                        Forfait
                      </label>
                    </div>
                    <div className='form-check form-check-inline'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        name='engraving'
                        checked={this.props.proposal.engraving == 1}
                        onClick={this.handeInput}
                        id='engraving'
                      />
                      <label className='form-check-label' htmlFor='engraving'>
                        Gravage
                      </label>
                    </div>
                    <div className='form-check form-check-inline'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        name='pref'
                        checked={this.props.proposal.pref == 1}
                        onClick={this.handeInput}
                        id='pref'
                      />
                      <label className='form-check-label' htmlFor='pref'>
                        Préfecture
                      </label>
                    </div>
                  </div>
                  <div className='form-group'>
                    <label className='h5 font-weight-bold'>Commentaire</label>
                    <input
                      type='text'
                      maxLength='100'
                      className='form-control'
                      name='comment'
                      value={this.props.proposal.comment ? this.props.proposal.comment : ''}
                      onChange={this.handeInput}
                    />
                    <small className='text-danger form-text'>Ce champ doit contenir moins de 100 caractères.</small>
                  </div>
                  <div className='form-group'>
                    <div className='form-check'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        name='sold'
                        checked={this.props.proposal.sold == 1}
                        onClick={this.handeInput}
                        id='sold'
                      />
                      <label className='form-check-label' htmlFor='sold'>
                        Vendu
                      </label>
                    </div>
                  </div>
                  <div className='form-group'>
                    <div className='form-check'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        name='sold_other'
                        checked={this.props.proposal.sold_other == 1}
                        onClick={this.handeInput}
                        id='sold_other'
                      />
                      <label className='form-check-label' htmlFor='sold_other'>
                        Vendu autre concession
                      </label>
                    </div>
                  </div>
                  <div className='form-group'>
                    <div className='form-check'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        name='sold_competition'
                        checked={this.props.proposal.sold_competition == 1}
                        onClick={this.handeInput}
                        id='sold_competition'
                      />
                      <label className='form-check-label' htmlFor='sold_competition'>
                        Vendu concurrence
                      </label>
                    </div>
                  </div>
                  {this.props.proposal.id != null && (
                    <div className='form-group'>
                      <label className='h5 font-weight-bold'>Fichiers associés</label>
                      <div className=''>
                        {/* <h6><li className="fas fa-plus-circle"> </li> Associer un fichier</h6> */}
                        <FileUpload uploadDone={this.uploadDone} basePath={'/Proposal/' + this.props.proposal.id + '/ '} />
                        <div>
                          <FileList ref={this.FileList} path={'/Proposal/' + this.props.proposal.id + '/'} />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className='modal-footer'>
              <button className='btn btn-primary float-right' onClick={() => this.props.onSubmit()}>
                <li className='fas fa-save'> </li> Enregistrer
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProposalForm;



// WEBPACK FOOTER //
// ./src/Components/Proposal/ProposalForm.js